import styled from 'styled-components';
import { rgba } from 'polished';
import { white, primary, neutral } from '../../style/colors';

// ============== Card Layout ==============
export const Card = styled.div`
  background-color: ${white};
  border-radius: 12px;
  padding: 8px;
  margin-bottom: 8px;
  border: 1px solid ${neutral[200]};
  position: relative;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: ${neutral[300]};
  }

  ${({ isInComparison }) => isInComparison && `
    border-color: ${primary[500]};
    background-color: ${rgba(primary[500], 0.02)};
  `}
`;

export const CardMain = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 3fr 1.2fr;
  gap: 16px;
  align-items: start;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 4px;
`;

export const CenterColumn = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 4px;

  @media (max-width: 968px) {
    order: -1;
    justify-content: flex-start;
  }
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;
`;

export const ExpandButton = styled.button`
  background: none;
  border: none;
  color: ${neutral[400]};
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
  padding: 4px 0;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: color 0.2s;
  margin-top: 4px;

  &:hover {
    color: ${neutral[500]};
  }

  i {
    font-size: 14px;
    transition: transform 0.3s;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
`;

export const BrandLogo = styled.img`
  height: 32px;
  max-width: 80px;
  object-fit: contain;
`;
